import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import Table from '../../shared/Table/Table';
import { getUniqDataLength } from '../../../utils/duplicate';
import { Tooltip } from '@material-ui/core';

const styles = (theme) => ({
  toolbarTextAbs: {
    color: theme.palette.common.black,
    borderBottom: 'solid 1px #efefef',
    zIndex: 1,
    paddingLeft: '24px',
    width: 'calc(100% - 24px)',
    overflow: 'hidden',
  },
  toolbarText: {
    color: theme.palette.common.black,
  },
  container: {
    width: 'calc(100% - 390px)',
    overflow: 'auto',
    position: 'relative',
  },
  dropDown: {
    marginLeft: 5,
    width: 'auto',
    maxWidth: 'calc(100% - 224px)',
  },
  select: {
    padding: 0,
    paddingBlock: 24,
    fontSize: 14,
    display: 'block',
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.common.green,
    paddingLeft: 5,
  },
  icon: {},
  userTitle: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
  },
});

const RightPanel = ({
  classes,
  data,
  table,
  step,
  parentClasses,
  onRoleChange,
  onRemove,
  selectedRole,
  roles = [],
}) => {
  const [isSelectOpen, setIsSelectOpen] = React.useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  const numberOfUsers = getUniqDataLength(data.user);
  const numberOfSpaces = getUniqDataLength(data.space);
  const userText = numberOfUsers > 1 ? 'users' : 'user';
  const spaceText = numberOfSpaces > 1 ? 'spaces' : 'space';

  const DataTable = ({ title, columns }) => (
    <Table
      bTitle={title} // block title, to differentiate with table title
      data={data[title]}
      columns={columns}
      onRemove={onRemove}
      disableFooter
      disableEmptyRows
      disableToolbarTitle
      singlePage
      {...table}
    />
  );

  const Placeholder = ({ title }) => (
    <div className={parentClasses.placeholderContainer}>
      <div className={parentClasses.placeholderTop}>{title}</div>
      <div className={parentClasses.placeholderImageContainer}>
        <img
          className={parentClasses.placeholderImage}
          src={table.image}
          alt="add users"
        />
      </div>
    </div>
  );

  const UserData = () => {
    if (data.user.length === 0) {
      return <Placeholder title="Start by selecting users." />;
    }
    return (
      <div>
        <DataTable title="user" columns={['name', 'externalId']} />
      </div>
    );
  };

  const SpaceData = () => {
    if (data.space.length === 0) {
      return <Placeholder title="Select spaces." />;
    }
    return <DataTable title="space" columns={['name', 'externalId']} />;
  };

  return (
    <div className={classes.container}>
      <div className={classes.toolbarTextAbs}>
        {numberOfUsers > 0 ? (
          <>
            <span className={classes.userTitle}>
              {`Adding ${numberOfUsers} ${userText} as`}
            </span>
            <span>
              <Tooltip
                title={
                  roles.find((role) => role.id === selectedRole)?.name || ''
                }
                placement="top"
                arrow
                open={isTooltipOpen && !isSelectOpen}
                onOpen={() => setIsTooltipOpen(true)}
                onClose={() => setIsTooltipOpen(false)}
                PopperProps={{
                  modifiers: {
                    offset: {
                      enabled: true,
                      offset: '0, -32',
                    },
                  },
                }}
              >
                <Select
                  className={classes.dropDown}
                  classes={{
                    selectMenu: classes.selectMenu,
                    select: classes.select,
                    icon: classes.icon,
                  }}
                  value={selectedRole || ''}
                  onOpen={() => setIsSelectOpen(true)}
                  onClose={() => setIsSelectOpen(false)}
                  onChange={(e) => {
                    onRoleChange(e.target.value);
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  disableUnderline
                >
                  {(!roles || roles.length === 0) && (
                    <MenuItem value="">Loading roles...</MenuItem>
                  )}
                  {roles &&
                    roles.length > 0 &&
                    roles.map((role) => {
                      const roleId = role.id || role._id;
                      const roleName =
                        role.name || role.title || 'Unknown Role';
                      if (!roleId) return null;
                      return (
                        <MenuItem key={roleId} value={roleId}>
                          {roleName}
                        </MenuItem>
                      );
                    })}
                </Select>
              </Tooltip>
            </span>
            {numberOfSpaces > 0 ? (
              <span className={classes.userTitle}>
                {`in ${numberOfSpaces} ${spaceText}`}
              </span>
            ) : null}
          </>
        ) : null}
      </div>
      {step === 'users' && <UserData />}
      {step === 'spaces' && <SpaceData />}
    </div>
  );
};

export default withStyles(styles as any, { withTheme: true })(RightPanel);
